/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auto_CorrectInputs */



/**
* | output |
* | --- |
* | "Auto Correct" |
*
* @param {Auto_CorrectInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const auto_correct = /** @type {((inputs?: Auto_CorrectInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auto_CorrectInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Correction automatique")
	if (locale === "de") return /** @type {LocalizedString} */ ("Automatische Korrektur")
	if (locale === "it") return /** @type {LocalizedString} */ ("Correzione automatica")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Автокоррекция")
	if (locale === "es") return /** @type {LocalizedString} */ ("Corrección automática")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("自动更正")
	if (locale === "ja") return /** @type {LocalizedString} */ ("自動修正")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ऑटो करेक्ट")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Correção automática")
	return /** @type {LocalizedString} */ ("Auto Correct")
});